// eslint-disable-next-line import/no-anonymous-default-export
export default {
  title: 'Giriş Yap',
  subtitle: 'Domain Control Paneline Hoş Geldiniz',
  username: 'Kullanıcı Adı',
  password: 'Şifre',
  rememberMe: 'Beni Hatırla',
  loginButton: 'Giriş Yap',
  loginError: 'Kullanıcı adı veya şifre hatalı',
  usernameRequired: 'Kullanıcı adı gerekli',
  passwordRequired: 'Şifre gerekli',
  loggingIn: 'Giriş yapılıyor...'
};
